import { httpClientAuthorized } from '../httpClient';
import { METHODS, ENDPOINTS } from 'shared/constants';

export interface WithdrawUSDTRequest {
  amount: number;
  wallet: string;
}

export interface WithdrawUSDTResponse {
  success: boolean;
  message?: string;
  transaction_id?: string;
  user?: any; // Should be AppUser type when backend returns updated user
}

export const withdrawUSDT = async (data: WithdrawUSDTRequest): Promise<WithdrawUSDTResponse> => {
  const response = await httpClientAuthorized<WithdrawUSDTResponse>({
    method: METHODS.POST,
    url: ENDPOINTS.WITHDRAW_USDT,
    data,
  });

  return response.data;
};
